export const SET_PROFILE_LOADING = 'SET_PROFILE_LOADING'
export const SET_PROFILE = 'SET_PROFILE'
export const DELETE_PROFILE = 'DELETE_PROFILE'
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA'
export const EDIT_PROFILE_DATA = 'EDIT_PROFILE_DATA'